import { addDatapointConfig } from 'owa-analytics-actions';
import { action, mutator, orchestrator } from 'satcheljs';
import type { CalendarEvent } from 'owa-calendar-types';
import { freeBusyCache, FreeBusyRow } from 'owa-freebusy-cache';
import { initializeRoomList } from './calendarRoomActions';
import { ObservableMap } from 'mobx';

const showRoomPanel = action(
    'showRoomPanel',
    (event: CalendarEvent, isConsumer: boolean, isDeepLink: boolean, viewStateId: string | null) =>
        addDatapointConfig(
            { name: 'showRoomPanel' },
            { event, isConsumer, isDeepLink, viewStateId }
        )
);

mutator(showRoomPanel, ({ isDeepLink }) => {
    if (isDeepLink) {
        let freeBusyData = new ObservableMap<string, ObservableMap<string, FreeBusyRow>>({});

        freeBusyCache.initialize(freeBusyData);
    }
});

orchestrator(showRoomPanel, ({ event, isConsumer, viewStateId }) => {
    initializeRoomList(
        isConsumer,
        event.Start,
        event.End,
        event.IsAllDayEvent,
        event.Recurrence,
        event.RequiredAttendees,
        event.OptionalAttendees,
        event,
        viewStateId
    );
});

export default showRoomPanel;
